<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    :retain-focus="false"
    persistent
    transition="dialog-bottom-transition">
     <!-- Boton de lapiz -->
     <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="btnDetails"
          v-bind="attrs"
          v-on="on" 
          icon    
          x-large
          dark
          text
          @click="dialogVisible = true"
          style="background-color: transparent;"
          >
            <v-icon color="primary">mdi-border-color</v-icon>
        </v-btn>
      </template>
    <v-card>
      <v-toolbar 
        dark 
        color="secondary">
        <v-btn 
          icon 
          dark 
          class="btn btn-primary" 
          @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Detalle de Novedad</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template> 

      </v-toolbar>

      <v-tabs-items v-model="tab" class="container mt-5">
              
        <v-tab-item>
          <div class="container mt-4">
            <formDetailNovelties
            :novelty="noveltyProps"
            />
          </div>
        </v-tab-item>

      </v-tabs-items>
      
    </v-card>
  </v-dialog>
</template>

<script>

import formDetailNovelties from "@/views/novelties/pages/detail_novelties/components/form_detail_novelties_component.vue"
import  EventBus  from '@/utils/event_bus.js'; 

export default {

  name: "detailNovelty",
  components: {
    formDetailNovelties
  },
  props: {
    noveltyProps: {
      required: true
    },
  },
  data() {
    return {
      dialogVisible: false,
      tab: null,    
      items: [
          "Datos Completos"
        ],
    };
  },

  mounted() {
    EventBus.$on('reload-update-novelties', async () => {
      this.closeDialog();
    })
  },
  
  methods: {    
    closeDialog() {
      this.$store.commit('RESET_STATE');
      this.dialogVisible = false; 
      window.location.reload();  
    }
  },

  
};
</script>

<style lang="css" scoped>

.btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 12px;
  }
</style>
